import { Component, OnInit } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-modal-info-plugins',
  templateUrl: './modal-info-plugins.component.html',
  styleUrls: ['./modal-info-plugins.component.scss']
})
export class ModalInfoPluginsComponent implements OnInit {

  constructor(
    public modalRef: MDBModalRef,
  ) { }

  ngOnInit(): void {
  }

  close() {
    return this.modalRef.hide();
  }
}
